import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Ink from 'react-ink';
import { useSubmitLead } from '../../hooks/useSubmitLead';
import { trackEvents } from '../TrackEvents';
import { EmailInputContext } from '../../contexts/EmailInputContext';
import { showToast } from './Toast';
import { brandName } from 'utils/utils';
const LEAD_TYPE = 'premium';

const EmailNameInputComponent = ({
  id,
  className,
  buttonBgColor = '#49C44F',
  acceptedTermsColor = 'text-[#1C2938]',
  acceptedTermsLinkColor = 'text-blue-900',
  buttonText = 'Submit'
}) => {
  const {
    firstName, setFirstName,
    lastName, setLastName,
    email, setEmail,
    acceptedMarketing, setAcceptedMarketing,
    acceptedTerms, setAcceptedTerms,
    buttonDisabled, setButtonDisabled
  } = useContext(EmailInputContext);
  const { submitLead, loading } = useSubmitLead();

  const brand = brandName(window.gon.current_brand)

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!firstName) {
      return showToast('Please enter a first name.', 'error');
    }

    if (!lastName) {
      return showToast('Please enter a last name.', 'error');
    }

    if (!email) {
      return showToast('Please enter a valid email address.', 'error');
    }

    if (!acceptedTerms) {
      return showToast('Please accept the terms to proceed.', 'error');
    }

    setButtonDisabled(true);

    console.log(acceptedMarketing)

    const response = await submitLead({
      firstName: firstName,
      lastName: lastName,
      email: email,
      campaignId: window.gon.campaign_id,
      campaignName: window.gon.campaign_name,
      acceptedMarketing: acceptedMarketing,
      acceptedTerms: acceptedTerms,
      leadType: LEAD_TYPE,
    });

    if (response.success) {
      showToast(response.message, 'success');
      trackEvents(response, { email });
    } else {
      setButtonDisabled(false);
      showToast(response.message, 'error');
    }
  };

  return (
    <div className={className}>
      <div>
        <form
          onSubmit={handleSubmit}
          className="
            flex flex-col items-center p-4
            bg-[#F8F9FB] bg-opacity-30 sm:shadow-lg rounded-[25px]
          "
        >
          <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-4 mb-4">
            <div className="flex-1 text-left mb-2 mt-4 p-3 sm:mb-0 bg-white w-full rounded-full sm:pt-1">
              <label htmlFor={`firstName-${id}`} className="hidden sm:block text-base font-medium text-[#1C2938] pl-6">
                First Name
              </label>
              <input
                id={`lastName-${id}`}
                type="text"
                placeholder="First Name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className="
                w-full h-14 sm:h-auto pl-8 sm:pl-6 text-base font-normal text-[#1C2938] text-opacity-60
                bg-transparent focus:outline-none rounded-full
              "
                disabled={buttonDisabled}
              />
            </div>

            <div className="flex-1 text-left mb-2 mt-4 p-3 sm:mb-0 bg-white w-full rounded-full sm:pt-1">
              <label htmlFor={`lastName-${id}`} className="hidden sm:block text-base font-medium text-[#1C2938] pl-6">
                Last Name
              </label>
              <input
                id={`lastName-${id}`}
                type="text"
                placeholder="Last Name"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className="
                w-full h-14 sm:h-auto pl-8 sm:pl-6 text-base font-normal text-[#1C2938] text-opacity-60
                bg-transparent focus:outline-none rounded-full
              "
                disabled={buttonDisabled}
              />
            </div>

          </div>

          <div className="flex-1 text-left mb-4 p-3 sm:mb-0 bg-white w-full rounded-full sm:pt-1">
            <label htmlFor={`emailAddress-${id}`} className="hidden sm:block text-base font-medium text-[#1C2938] pl-6">
              Email Address
            </label>
            <input
              id={`emailAddress-${id}`}
              type="email"
              placeholder="email@domain.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="
                w-full h-14 sm:h-auto pl-8 sm:pl-6 text-base font-normal text-[#1C2938] text-opacity-60
                bg-transparent focus:outline-none rounded-full
              "
              disabled={buttonDisabled}
            />
          </div>

          <div className="w-full flex text-start justify-start mt-2 md:mt-4">
            <input
              id={`marketingCheckbox-${id}`}
              type="checkbox"
              checked={acceptedMarketing}
              onChange={(e) => setAcceptedMarketing(e.target.checked)}
              className="form-checkbox mt-2 mr-2"
              disabled={buttonDisabled}
            />
            <label htmlFor={
              `marketingCheckbox-${id}`} className={`mt-2 ${acceptedTermsColor} text-xs 
              sm:text-sm font-medium text-white`
              }>
              Yes, I’d like to receive promotional emails, special offers, and news from {brand}.
            </label>
          </div>

          <div className="w-full flex text-start justify-start mb-6">
            <input
              id={`termAndConditionsCheckbox-${id}`}
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              className="form-checkbox mt-2 mr-2"
              disabled={buttonDisabled}
            />
            <label htmlFor={
              `termAndConditionsCheckbox-${id}`} className={`mt-2 ${acceptedTermsColor} text-xs 
              sm:text-sm font-normal text-white `
              }>
              Yes, I agree to the&nbsp;

              <a className={
                `text-white underline ${acceptedTermsLinkColor}`}
                href={window.origin + '/ireland-dreamgolfgetaway-terms'
                } target="_blank" rel="noopener noreferrer">
                Official Sweepstakes Rules
              </a>

              ,&nbsp;{brand}&nbsp;
              <a className={
                `text-white underline ${acceptedTermsLinkColor}`} href={window.origin + '/terms'
                } target="_blank" rel="noopener noreferrer">
                Terms of use
              </a>
              {', and '}
              <a className={
                `text-white underline ${acceptedTermsLinkColor}`} href={window.origin + '/privacy'
                } target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </a>.
            </label>
          </div>

          <button
            type="submit"
            className={`
              w-full sm:w-auto h-[59px] px-11 py-3 text-white font-medium
              text-lg rounded-full relative
              ${buttonDisabled || loading ? 'opacity-50 cursor-not-allowed' : ''}
            `}
            style={{ backgroundColor: buttonBgColor }}
            disabled={buttonDisabled || loading}
          >
            {buttonText}
            {!buttonDisabled && !loading && <Ink />}
          </button>
        </form>
      </div >
    </div >
  );
};

EmailNameInputComponent.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  buttonBgColor: PropTypes.string,
  acceptedTermsColor: PropTypes.string,
  acceptedTermsLinkColor: PropTypes.string,
  buttonText: PropTypes.string
};

export default EmailNameInputComponent;
